import {
  DefaultAvatar,
  DefaultGuideImage,
  DefaultImage,
  DefaultPodcastImage,
  DefaultVideoImage,
} from '@shared/ui-components/assets/';

import SecondaryFallbackImage from '../../image-wrapper/fallback-image-2.svg';
import DefaultFallbackImage from '../../image-wrapper/fallback-image.svg';

const PLACEHOLDER_IMAGES = [
  DefaultAvatar,
  DefaultGuideImage,
  DefaultImage,
  DefaultPodcastImage,
  DefaultVideoImage,
];

const PLACEHOLDER_ASSETS = [DefaultFallbackImage, SecondaryFallbackImage];

const LARGEST_IMAGE_WIDTH = 3840;

const NEXT_IMAGE_WIDTHS = [
  16,
  32,
  48,
  64,
  96,
  128,
  256,
  384,
  640,
  750,
  828,
  1080,
  1200,
  1920,
  2048,
  LARGEST_IMAGE_WIDTH,
];

const NEXT_DEFAULT_QUALITY = 75;

const SMALLEST_PLACEHOLDER_WIDTH = 640;

// Placeholders stand in for cards and avatars, so they are requested at the slot widths
// those components actually occupy rather than at the full viewport width.
const PLACEHOLDER_SLOT_FRACTIONS = [0.25, 0.5];

const toDeviceSizeCovering = (width: number) =>
  NEXT_IMAGE_WIDTHS.find((size) => size >= width) ?? LARGEST_IMAGE_WIDTH;

const toOptimizedImageUrl = (source: string, width: number) =>
  `/_next/image?url=${encodeURIComponent(source)}&w=${width}&q=${NEXT_DEFAULT_QUALITY}`;

const getPlaceholderWidths = () => {
  const deviceWidth = window.innerWidth * (window.devicePixelRatio || 1);

  return [
    ...new Set([
      SMALLEST_PLACEHOLDER_WIDTH,
      ...PLACEHOLDER_SLOT_FRACTIONS.map((fraction) =>
        toDeviceSizeCovering(Math.ceil(deviceWidth * fraction))
      ),
    ]),
  ];
};

export const getPlaceholderImageUrls = () => {
  const widths = getPlaceholderWidths();

  return PLACEHOLDER_IMAGES.flatMap((image) =>
    widths.map((width) => toOptimizedImageUrl(image.src, width))
  );
};

export const getPlaceholderAssetUrls = () => PLACEHOLDER_ASSETS.map((asset) => asset.src);
